import React, { SVGProps } from "react";

import {
    Text,
    TextStyle,
    TouchableOpacity,
    TouchableOpacityProps
} from "react-native";

import AppTheme from "../../utils/Theme";

interface LinkButtonProps extends TouchableOpacityProps {
    color?: string,
    title?: string,
    textStyle?: TextStyle
}

const LinkButton = (props: LinkButtonProps) => {

    const appTheme: AppTheme = new AppTheme();
    const { color = appTheme.darkBlue, title="OK", textStyle, ...restProps } = props;

    let linkButtonStyle: TextStyle[] = [{color, fontFamily:appTheme.secondaryFont, fontSize:appTheme.pixelPerfectForFont(7), textDecorationLine:"underline"}];
    if (textStyle !== undefined) {
        linkButtonStyle.push(textStyle);
    }

    return <TouchableOpacity {...restProps}>
        <Text style={linkButtonStyle}>{title}</Text>
    </TouchableOpacity>
}

export default LinkButton;